import { ReactElement } from 'react';
import { FormListFieldData, FormListOperation } from 'antd/es/form';
import { BaseBlock } from '../../../../../components/styles/Block';
import ContentBodyLayout from './ContentBodyLayout';
import TableHeader from './TableHeader';
import TableRows from './TableRows';
import { BulkCreateCustomersResponse } from '@minutes-system/backend/src/api/customers/schema';

interface Props {
  fields: FormListFieldData[];
  onRemove: FormListOperation['remove'];
  minRows: number;
  results: BulkCreateCustomersResponse | null;
}

const ContentBody = ({ fields, onRemove, minRows, results }: Props): ReactElement => (
  <BaseBlock as='section'>
    <ContentBodyLayout
      header={<TableHeader />}
      body={<TableRows fields={fields} onRemove={onRemove} minRows={minRows} results={results} />}
    />
  </BaseBlock>
);

export default ContentBody;
